import { Building2, MapPin, Euro } from "lucide-react";
import type { ToolWidgetProps } from "./index";
import { ProfileCardActions } from "./profile-card-actions";

interface Enseigne {
  id: number;
  name: string;
  user_id?: number;
  secteur?: string;
  parent_secteur?: string;
  chalandise?: number;
  contribution?: number;
  global_invest?: number;
  surface_min?: number;
  surface_max?: number;
  point_of_sales_count?: number;
}

interface SearchEnseignesData {
  results: Enseigne[];
  total: number;
}

function EnseigneCard({ enseigne }: { enseigne: Enseigne }) {
  return (
    <div className="flex flex-col gap-2 p-3 bg-white rounded-lg border border-slate-200 hover:border-slate-300 transition-colors relative">
      <ProfileCardActions
        profile={{
          type: "enseigne",
          id: enseigne.id,
          name: enseigne.name,
          user_id: enseigne.user_id,
        }}
      />
          <div className="w-10 h-10 rounded-lg bg-slate-100 flex items-center justify-center">
            <Building2 className="w-5 h-5 text-slate-400" />
          </div>
          <div className="min-w-0">
            <div className="font-medium text-slate-800 truncate">
              {enseigne.name}
            </div>
            {enseigne.secteur && (
              <div className="text-xs text-slate-500 truncate">{enseigne.secteur}</div>
            )}
            <div className="flex flex-col gap-1 mt-2 text-xs text-slate-500">
              {enseigne.contribution && (
                <div className="flex items-center gap-1">
                  <Euro className="w-3 h-3" />
                  {enseigne.contribution.toLocaleString("fr-FR")} €
                </div>
              )}
              {(enseigne.surface_min || enseigne.surface_max) && (
                <div>
                  {enseigne.surface_min || 0}-{enseigne.surface_max || 0} m²
                </div>
              )}
              {enseigne.point_of_sales_count !== undefined && enseigne.point_of_sales_count > 0 && (
                <div className="flex items-center gap-1">
                  <MapPin className="w-3 h-3" />
                  {enseigne.point_of_sales_count} {enseigne.point_of_sales_count === 1 ? 'point de vente' : 'points de vente'}
                </div>
              )}
            </div>
          </div>
    </div>
  );
}

export function SearchEnseignesWidget({
  data,
  count,
}: ToolWidgetProps<SearchEnseignesData>) {
  const { results = [] } = data || {};

  if (!results.length) {
    return (
      <div className="text-sm text-slate-500 italic">
        Aucune enseigne trouvée
      </div>
    );
  }

  return (
    <div className="grid grid-cols-4 gap-3">
      {results.map((enseigne) => (
        <EnseigneCard key={enseigne.id} enseigne={enseigne} />
      ))}
      {count && count > results.length && (
        <div className="col-span-4 text-xs text-slate-400 text-center pt-1">
          + {count - results.length} autres résultats
        </div>
      )}
    </div>
  );
}
